// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2kTyx","label":"Radio_label__2wMEV","checkMark":"Radio_checkMark__3ceRY","disabled":"Radio_disabled__3ICXg"};